"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.slice.js");

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _CircleEllipsis = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-action/svgr/CircleEllipsis"));

var _style = require("./style");

var _Item = _interopRequireDefault(require("./Item"));

Resources.propTypes = {
  /**
   * 数据源
   */
  dataSource: _propTypes["default"].array,

  /**
   * 自定义渲染方式
   * @argument {any} item - 数据源中的单个item
   * @argument {number} index - 数据源中item的index值
   */
  renderItem: _propTypes["default"].func,

  /**
   * 展示数量，超过数量的item需要hover图标展示
   */
  visibleCount: _propTypes["default"].number,

  /**
   * hover浮层内展示的最大数量，不传则不限制数量
   */
  hiddenCount: _propTypes["default"].number,

  /**
   * hover浮层内的额外信息
   */
  extra: _propTypes["default"].node,

  /**
   * 无数据时的展示内容
   */
  emptyContent: _propTypes["default"].node,

  /**
   * hover浮层的样式
   */
  popupStyle: _propTypes["default"].object
};
Resources.defaultProps = {
  visibleCount: 2
};

function Resources(_ref) {
  var _this = this;

  var dataSource = _ref.dataSource,
      renderItem = _ref.renderItem,
      visibleCount = _ref.visibleCount,
      hiddenCount = _ref.hiddenCount,
      extra = _ref.extra,
      emptyContent = _ref.emptyContent,
      popupStyle = _ref.popupStyle;

  if (!(0, _isArray["default"])(dataSource) || !dataSource.length) {
    return emptyContent === void 0 ? null : emptyContent;
  }

  if (visibleCount < 0) {
    return null;
  }

  dataSource = dataSource.map(function (d, i) {
    (0, _newArrowCheck2["default"])(this, _this);
    return {
      data: d,
      index: i
    };
  }.bind(this));

  var isLast = function isLast(datas, index) {
    (0, _newArrowCheck2["default"])(this, _this);
    return index === datas.length - 1;
  }.bind(this);

  var renderHidden = function renderHidden(datas, render, extra) {
    var _this2 = this;

    (0, _newArrowCheck2["default"])(this, _this);
    return datas.length ? /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
      placement: "bottomLeft",
      arrow: false,
      popup: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, datas.map(render), extra),
      popupStyle: popupStyle || {},
      getPopupContainer: function () {
        (0, _newArrowCheck2["default"])(this, _this2);
        return document.body;
      }.bind(this)
    }, /*#__PURE__*/_react["default"].createElement(_CircleEllipsis["default"], {
      className: _style.iconCls
    })) : null;
  }.bind(this);

  var _renderItem = typeof renderItem === "function" ? function (item) {
    (0, _newArrowCheck2["default"])(this, _this);
    return renderItem(item.data, item.index);
  }.bind(this) : function (item) {
    (0, _newArrowCheck2["default"])(this, _this);
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: item.index
    }, item.data);
  }.bind(this);

  var visibleDatas = dataSource.slice(0, visibleCount);
  var hiddenDatas = hiddenCount < 0 ? [] : dataSource.slice(visibleCount).slice(0, hiddenCount);
  return /*#__PURE__*/_react["default"].createElement(_style.StyledWrapper, null, visibleDatas.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style.listCls
  }, visibleDatas.map(function (item, i) {
    (0, _newArrowCheck2["default"])(this, _this);

    if (isLast(visibleDatas, i)) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "last-item-".concat(i)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style.lastItemCls
      }, _renderItem(item)), renderHidden(hiddenDatas, _renderItem, extra));
    }

    return _renderItem(item);
  }.bind(this))) : null);
}

var _default = Resources;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Resources/Resources.js
// module id = 2159
// module chunks = 6 7 17 18